/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { PicturesData } from '../../../../api/samples/types';
import {
  IconArrowBackMS,
  IconArrowForwardIosMS,
  IconCloseMS,
} from '../../../../constants/icons';
import { ColoredCircularProgress } from '../../../UI/Typography';
import {
  ArrowButton,
  CloseButton,
  ContainerModal,
  MainBox,
  MainCardMedia,
  MoreImages,
  PicturesContainer,
  ScrollContainer,
  StyledBox,
  StyledCardMedia,
  ThumbCardMedia,
} from './styles';

interface AllPicturesSliderProps {
  file: PicturesData;
  images: PicturesData[];
  getMorePictures(): Promise<void>;
  loading: boolean;
  isUpdated: boolean;
}

export default function AllPicturesSlider({
  file,
  images,
  getMorePictures,
  loading,
  isUpdated,
}: AllPicturesSliderProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const { length } = images;

  const nextImage = (): void => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevImage = (): void => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  useEffect(() => {
    if (open) {
      const index = images.findIndex((image) => image.file === file.file);
      if (index !== -1) {
        setCurrent(index);
      } else {
        setCurrent(0);
      }
    }
  }, [open]);

  return (
    <>
      <StyledCardMedia
        image={file.file}
        title={file.file}
        onClick={handleOpen}
      />
      <ContainerModal
        open={open}
        onClose={handleClose}
        aria-labelledby="picture dialog"
      >
        <StyledBox>
          <MainBox>
            <CloseButton onClick={handleClose}>{IconCloseMS}</CloseButton>
            <ArrowButton disableTouchRipple onClick={prevImage}>
              {IconArrowBackMS}
            </ArrowButton>
            {images.map(
              (slide, index) =>
                index === current && (
                  <MainCardMedia
                    key={slide.id ? slide.id : slide.caption}
                    image={slide.file}
                    title={slide.caption}
                    component="img"
                  />
                )
            )}
            <ArrowButton disableTouchRipple onClick={nextImage}>
              {IconArrowForwardIosMS}
            </ArrowButton>
          </MainBox>
          <PicturesContainer>
            <ScrollContainer>
              {images.map((slide, index) => (
                <ThumbCardMedia
                  key={slide.id ? slide.id : slide.caption}
                  image={slide.file}
                  component="img"
                  onClick={() => setCurrent(index)}
                />
              ))}
              {!isUpdated && (
                <MoreImages
                  disabled={loading}
                  onClick={() => {
                    getMorePictures();
                    setCurrent(0);
                  }}
                >
                  {loading ? (
                    <ColoredCircularProgress size={32} />
                  ) : (
                    'Mais imagens'
                  )}
                </MoreImages>
              )}
            </ScrollContainer>
          </PicturesContainer>
        </StyledBox>
      </ContainerModal>
    </>
  );
}
